var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { CSearchPaginateLabel } from '@/components/modules/pages/consultantSearch/Navigation/CSearchPaginate/CSearchPaginateLabel';
import { Paginate } from '@/components/ui/Navigation/Paginate';
export const CSearchPaginate = (props) => {
    const { disabled, onClick } = props, otherProps = __rest(props, ["disabled", "onClick"]);
    const pageLabelBuilder = useCallback((page) => _jsx(CSearchPaginateLabel, { disabled: disabled, value: page }), [disabled]);
    return (_jsx(Paginate, Object.assign({ nextLabel: _jsx(CSearchPaginateLabel, { disabled: disabled, value: '>' }), onClick: onClick, pageLabelBuilder: pageLabelBuilder, previousLabel: _jsx(CSearchPaginateLabel, { disabled: disabled, value: '<' }) }, otherProps)));
};
